import React from 'react';
import { useLocation } from "react-router-dom";
import { useSelector } from 'react-redux';
import { useNavigate, Link } from 'react-router-dom';

const Artical = () => {
  const eventData = useSelector((state) => state.event.eventData);
  const artical = eventData.articles || {};
  const backgroundImage = eventData.people?.imageKey;
  const navigate = useNavigate();

  const location = useLocation();
  const { item } = location.state || {};
  const items = Array.isArray(item) ? item : [item]; // Always work with an array

  return (
    <div>
      {/* Top Section with background */}
      <section
        className="tour-area position-relative bg-top-center overflow-hidden space"
        id="service-sec"
        style={{
          backgroundImage: `linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.5)), url(${backgroundImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-6 offset-lg-3">
              <div className="title-area text-center">
                <h2 className="sec-title">{artical.subTitle}</h2>
                <span className="sub-title">{artical.title}</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Articles Section */}
      <section className="position-relative overflow-hidden space-bottom" id="destination-sec">
        <div className="container">
          <div className="row gy-4 gx-4">
            {items.map((article, idx) => (
              <div className="col-xl-4 col-lg-6 col-md-6" key={idx}>
                <div className="destination-item th-ani" style={{ border: "1px solid gray", padding: '20px' }}>
                  <div className="destination-item_img global-img text-center mb-3">
                    <img
                      src={article.imageKey}
                      alt={article.name}
                      style={{ maxWidth: '100%', borderRadius: '10px' }}
                    />
                  </div>
                  <div className="destination-content text-center">
                    <h3 className="box-title">{article.name}</h3>
                    <p className="destination-text text-muted">{article.date}</p>
                    <p className="destination-text">{article.address}</p>
                  </div>
                  <a onClick={() => navigate('/event/details', { state: { item: article, description: "aritical" } })}>
  View
</a>

                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Artical;
